import { Flex } from "styled-system/jsx";
import { Text } from "@ttc3k/trekker";
import { WhereaboutsLogo } from "shared/components";
import { useTranslation } from "react-i18next";

export const PoweredByWhereabouts = () => {
  const { t } = useTranslation();
  return (
    <Flex
      gap={"75"}
      alignItems={{ base: "flex-start", md: "center" }}
      flexDir={{ base: "column", md: "row" }}
    >
      <Text visual={"smallRegular"} color={"text.light"}>
        {t("core:POWERED_BY")}
      </Text>
      <WhereaboutsLogo width={121} height="auto" />
    </Flex>
  );
};
